import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { CustomerContactForm } from "../components/ContactForm/ContactForm";



const searchRoot = document.getElementById('contact-form') as HTMLElement;

if (searchRoot) {

  const root = ReactDOM.createRoot(searchRoot);

  root.render(
    <CustomerContactForm />
  );

}